import AppDispatcher from 'dispatcher/AppDispatcher'
import State from 'stores/State'
import defaultErrorMapper from 'mappers/DefaultErrorMapper'
import errorReducer from 'reducers/ErrorReducer'

import NetworkConstants from 'constants/NetworkConstants';

var _ = require('underscore');

var EventEmitter = require('events').EventEmitter;

var ErrorStore = _.extend({}, EventEmitter.prototype, {
  getError: function() {
    return defaultErrorMapper(State.get()).error;
  },

  // Emit Change event
  emitChange: function() {
    this.emit('change');
  },

  // Add change listener
  addChangeListener: function(callback) {
    this.on('change', callback);
  },

  // Remove change listener
  removeChangeListener: function(callback) {
    this.removeListener('change', callback);
  }
});

// Register callback with AppDispatcher
AppDispatcher.register(function(payload) {
  var action = payload.action;
  switch(action.actionType) {
    case NetworkConstants.NETWORK_ERROR:
      State.set(errorReducer(action, State.get()));
    break;
    default:
      return true;
  }

  ErrorStore.emitChange();
  return true;
});

export default ErrorStore
